import React from "react";

const SymposiumPengembanganRiset: React.FC = () => {
    return (
        <div className="text-justify py-4">
            <h2 className="text-lg font-semibold mb-3">
                📄 Student Symposium Research Paper sebagai Wadah Pengembangan Budaya Riset
            </h2>

            <p className="mb-4">
                Perkembangan dunia pendidikan saat ini menuntut siswa dan mahasiswa untuk tidak hanya memahami teori, tetapi juga mampu menuangkan gagasan secara sistematis dan ilmiah. Kebutuhan akan literasi riset sejak dini mendorong munculnya berbagai forum akademik dan kompetisi penulisan ilmiah yang berfokus pada pengembangan kemampuan riset pelajar.
            </p>

            <p className="mb-4">
                Salah satu ajang yang telah lama dikenal adalah{' '}
                <a
                    href="https://lomba.brin.go.id/lkir"
                    className="text-blue-600 underline font-semibold hover:text-blue-800"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Lomba Karya Ilmiah Remaja (LKIR)
                </a>
                , yang secara konsisten mendorong budaya penelitian di kalangan generasi muda.
            </p>

            <h3 className="text-md font-semibold mb-2">
                🎓 Student Symposium Research Paper
            </h3>

            <p className="mb-4">
                Sejalan dengan semangat tersebut, Student Symposium Research Paper hadir sebagai wadah akademik yang melatih peserta dalam penulisan karya ilmiah terstruktur. Program ini dirancang untuk mengasah kemampuan berpikir kritis, analitis, serta keterampilan menyusun argumen berbasis data dan referensi ilmiah.
            </p>

            <p className="mb-4">
                Melalui pendekatan ini, peserta tidak hanya berlatih menulis, tetapi juga membangun fondasi riset yang relevan dengan kebutuhan akademik masa kini.
            </p>

            <h3 className="text-md font-semibold mb-2">
                🧠 Proses dan Metodologi Penulisan Ilmiah
            </h3>

            <p className="mb-4">
                Dalam proses penyusunan research paper, peserta diajak untuk mengidentifikasi permasalahan, merumuskan tujuan penelitian, mengolah data, hingga menyajikan hasil kajian secara runtut dan berbasis fakta.
            </p>

            <p className="mb-4">
                Tahapan ini melatih ketelitian, konsistensi, serta kemampuan mengelola referensi dari sumber terpercaya. Metode pembelajaran seperti ini juga banyak diterapkan dalam berbagai forum akademik dan kompetisi karya ilmiah sebagai bagian dari persiapan menuju pendidikan tinggi dan dunia riset.
            </p>

            <h3 className="text-md font-semibold mb-2">
                🏆 Prestasi Akademik dan Relevansi Riset
            </h3>

            <p className="mb-4">
                Pentingnya keterampilan riset dan penulisan ilmiah tercermin dari berbagai capaian akademik terbaru.{' '}
                <a
                    href="https://lldikti5.kemdikbud.go.id/home/detailpost/mahasiswa-fh-uad-raih-juara-i-artikel-ilmiah-nasional-2025"
                    className="text-blue-600 underline font-semibold hover:text-blue-800"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Mahasiswa Universitas Ahmad Dahlan
                </a>{' '}
                berhasil meraih juara dalam Kompetisi Artikel Ilmiah Tingkat Nasional 2025, yang menilai kualitas analisis, metodologi, dan sistematika penulisan karya ilmiah.
            </p>

            <p className="text-gray-700">
                Melalui program yang dihadirkan oleh <strong>IIT</strong>, Student Symposium Research Paper menjadi media pembelajaran yang terarah dan relevan dengan kebutuhan akademik masa kini. IIT mendukung peserta untuk mengembangkan kemampuan riset dan komunikasi ilmiah sebagai bekal penting dalam dunia pendidikan dan profesi di masa depan.
            </p>

            <p className="mt-4 font-semibold">
                👉 Cek informasi{' '}
                <a
                    href="/iit-program?program=Symposium"
                    className="text-blue-600 underline font-semibold hover:text-blue-800"
                    target="_blank"
                >
                    Student Symposium Research Paper
                </a>{' '}
                lebih lanjut
            </p>
        </div>
    );
};

export default SymposiumPengembanganRiset;
